import { SelectLang as UmiSelectLang, useIntl } from '@umijs/max';
import React from 'react';

export const SelectLang: React.FC = () => {
  const intl = useIntl();
  return (
    <UmiSelectLang
      icon={
        <span style={{ fontSize: 14, fontStyle: 'normal' }}>
          {intl.formatMessage({
            /** 使用顶层 locale key，避免部分环境下长 id 未进 messages 而回显 key */
            id: 'navBar.lang',
            defaultMessage: '语言',
          })}
        </span>
      }
      style={{
        padding: '4px 8px',
        fontSize: 14,
      }}
    />
  );
};

export { default as ThemeToggle } from './ThemeToggle';
